import { useState, useEffect } from "react";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";

const Terms = () => {
  const [styles, setStyles] = useState({
    container: {
      minHeight: "1491px",
      margin: "120px 0px 60px 0px",
    },

    h3: {
      fontSize: "32px",
      fontWeight: "700",
      lineHeight: "16px",
      textAlign: "left",
      color: "#000",
      marginBottom: "38px",
    },

    p: {
      fontSize: "16px",
      fontWeight: "500",
      // lineHeight: "28px",
      // textAlign: "left",
    },

    h5: {
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "28px",
    },

    article: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "28px",
      paddingBottom: "38px",
    },
  });

  useEffect(() => {
    const updateStyles = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 600) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxHeight: "4103px",
            margin: "132px 12px 86px 12px",
          },
          h3: {
            ...prevStyles.h3,
            fontSize: "24px",
            marginBottom: "24px",
          },
          h5: {
            ...prevStyles.h5,
            fontSize: "16px",
          },
          article: {
            ...prevStyles.article,
            fontSize: "14px",
          },
        }));
      } else if (screenWidth <= 780) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxHeight: "3516px",
          },
        }));
      } else if (screenWidth <= 920) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxHeight: "3116px",
          },
        }));
      }
    };

    updateStyles();
    window.addEventListener("resize", updateStyles);

    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  return (
    <div>
      <NavBar linkColor="#000000" logo={ColoredLogo} bg="#fff" />
      <div className="container tofSection" style={{ width: "86%" }}>
        <div style={styles.container}>
          <h3 style={styles.h3}>Terms of Use</h3>
          <article style={styles.article}>
            Welcome to use this service! Before registering and using, please
            read and understand the following terms carefully. Your use means
            that you agree and accept all the terms of this agreement.
          </article>

          <h5 style={styles.h5}>1. Legal Agreement</h5>
          <article style={styles.article}>
            Registration and use of this service constitutes a legal agreement
            between you and us. If you do not agree with any terms in this
            agreement, please stop using this platform right away.
          </article>

          <h5 style={styles.h5}>2. Information Collection and Privacy</h5>
          <article style={styles.article}>
            To provide and improve our services, we collect user information as
            needed. We also take strong steps to protect your privacy. For
            details, please see [Privacy Policy]. Please ensure that all
            information provided is true and accurate to ensure the normal
            operation of the service.
          </article>

          <h5 style={styles.h5}>3. Account Management and Security</h5>
          <article style={styles.article}>
            • Information Accuracy: You must provide accurate account
            information, including real name and contact information. If the
            information is false, we have the right to suspend or terminate the
            account.
            <br />
            • Account Security: You are responsible for protecting your account
            information and avoiding account leakage because of personal
            reasons. I recommend enabling two-factor authentication to increase
            security.
            <br />
            You must not share, rent, or transfer accounts unless you receive
            specific authorization. The user shall bear any losses caused by
            account sharing. If someone uses your account without permission,
            please tell us right away. This will help us take protective
            measures.
          </article>

          <h5 style={styles.h5}>4. User behaviour and prohibited activities</h5>
          <article style={styles.article}>
            Users must comply with all applicable laws and regulations and are
            prohibited from engaging in the following behaviours:
            <br />
            • Illegal activities: Any illegal or unauthorized transactions are
            prohibited, including but not limited to fraud, money laundering,
            etc.;
            <br />
            • Platform interference: No attempt to obtain unauthorized access,
            attack the system, destroy data or bypass any security measures;
            <br />
            • Malware transmission: Uploading or spreading viruses, malware,
            phishing attacks, etc. is prohibited.
            <br />
            • Improper use: No abuse of services or false transactions are
            allowed, and the platform has the right to make judgments and handle
            them.
            <br />
            We can suspend or end a user's account service right away if they
            break the code of conduct.
          </article>

          <h5 style={styles.h5}>
            5. Scope of service and limitation of liability
          </h5>
          <article style={styles.article}>
            We will work hard to keep the service stable. However, we are not
            responsible for any losses from service interruptions, information
            loss, or delays. We are not responsible for any losses from using
            this service. This includes direct or indirect losses, like data
            loss or lost income.
          </article>

          <h5 style={styles.h5}>6. Payment Terms and Fee Adjustment</h5>
          <article style={styles.article}>
            Payment and Fees: Users must pay the fees for the Service. They also
            agree to follow the Platform's fee policy.
            <br />
            • Price Adjustment: We reserve the right to adjust fees according to
            market changes and will notify users in advance.
            <br />• Refund Policy: All fees are non-refundable once paid, unless
            otherwise provided by law or Platform policy.
          </article>

          <h5 style={styles.h5}>7. Reasonable Use of Services</h5>
          <article style={styles.article}>
            Users should use the Services legally and reasonably. They must not
            abuse or interfere with other users. They should not disrupt the
            normal operation of the Platform. Any violation of the Reasonable
            Use Policy will result in account restriction or termination.
          </article>

          <h5 style={styles.h5}>8. Changes to Terms and Notice</h5>
          <article style={styles.article}>
            We reserve the right to update or modify these Terms. The Platform
            will post notices, and Users who continue to use it will accept the
            changes.
          </article>

          <h5 style={styles.h5}>9. Dispute Resolution</h5>
          <article style={styles.article}>
            We reserve the right to update or modify these Terms. The Platform
            will post notices, and Users who continue to use it will accept the
            changes.
          </article>

          <h5 style={styles.h5}>10. Applicable Law and Jurisdiction</h5>
          <article style={styles.article}>
            This Agreement shall be governed by [Applicable Law] and all
            disputes shall be resolved in [Location of Jurisdiction].
          </article>

          <h5 style={styles.h5}>11. Intellectual Property Protection</h5>
          <article style={styles.article}>
            All content on the Platform belongs to the Platform or its
            licensors. This includes text, graphics, icons, images, audio clips,
            and software. You cannot use it for commercial purposes without
            permission.
          </article>

          <h5 style={styles.h5}>12. User Indemnification Obligation</h5>
          <article style={styles.article}>
            The user agrees to take responsibility for any losses, claims,
            expenses, and damages to the Platform. This includes costs from
            breaking the terms of this Agreement, such as reasonable attorney
            fees.
          </article>

          <h5 style={styles.h5}>13. Force Majeure</h5>
          <article style={styles.article}>
            We are not responsible for delays or interruptions caused by events
            beyond our control. This includes natural disasters, network
            failures, war, and government actions.
          </article>

          <h5 style={styles.h5}>14. Right of Termination</h5>
          <article style={styles.article}>
            The Platform can end a user's access to the Service at any time.
            This is especially true if the user breaks the rules of this
            Agreement. If that happens, the Platform can quickly suspend or
            terminate the user's account.
          </article>

          <h5 style={styles.h5}>15. Contact Us</h5>
          <article style={styles.article}>
            If you have any questions or need help, please contact us through
            the following methods:
            <br />
            Email: gcard8business@giftcard8.com
            <br />
            WhatsApp: +447704521940
          </article>

          {/* <br /> */}
          <p className="p">Updated: November 2024</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
